module.exports = __webpack_public_path__ + "static/media/lightsup.ce9603eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/screenshots/lite/lightsup.png
// module id = 832
// module chunks = 20